// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"qp-z","slideIn":"rp-z"};